import { Component, Input, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-race-list',
  templateUrl: './race-list.component.html',
  styleUrls: ['./race-list.component.css']
})
export class RaceListComponent extends BaseClass<any> implements OnInit {

  @Input() list: any;
  @Input() id: any;
  @Input() isHorizon: boolean = false;
  public data: any
  constructor(public _common: CommonService, public service: WebserviceService) { super()}

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  ngOnChanges() {
    if (this.list) {
      this.data = this.isHorizon ? this.list : this.reArrangeRaceData(this.list);
    }
  }
  groupBy<K, V>(list: Array<V>, keyGetter: (input: V) => K) {
    const map = new Map();
    list.forEach((item: any) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  listByTypeId(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    return grouped.get(id) ? grouped.get(id) : [];
  }

  reArrangeRaceData(items: any) {
    items = this.listByTypeId(items, this.id);
    let rc = items.map((a: any) => (a.event_country_code));
    const uniqueSet1 = new Set(rc);
    rc = [...uniqueSet1];
    rc = rc.map((a: any) => ({ event_country_code: a, data: [] }));
    const grouped = this._common.groupBy(items, (dat: any) => dat.event_country_code);

    rc.forEach((element: any) => {
      let dt = grouped.get(element.event_country_code) ? grouped.get(element.event_country_code) : [];
      let rcd = dt.map((a: any) => (a.event_id));
      const uniqueSet1 = new Set(rcd);
      rcd = [...uniqueSet1];
      rcd = rcd.map((a: any) => ({ event_id: a, event_name: '', data: [] }));
      const groupedByEvent = this._common.groupBy(dt, (dat: any) => dat.event_id);

      rcd.forEach((eEle: any) => {
        eEle.data = [...eEle.data, ...groupedByEvent.get(eEle.event_id) ? groupedByEvent.get(eEle.event_id) : []]
        eEle.event_name = eEle.data[0]?.event_name;
      });

      element.data = rcd
    });

    return rc;
  }
  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
